import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Spin, Space, DatePicker } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import './module.css';
const { TabPane } = Tabs;
const Department = (props) => {
    const [form] = Form.useForm();
    const activeInd = Form.useWatch('activeInd', form);
    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});

    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [moduleModel, setModuleModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const tableColumns = {
        deptCode: "deptCode",
    }

    const disabledDate = current => {
        return current && current > moment().endOf('day');
    };

    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("module/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));

    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        // search(pageSize, 1, "reset")
    }



    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ activeInd: 'Y' });
        setGroupMemberTables([]);
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        searchById(model.moduleId)
        setTabIndex("2");
        setFlag("edit");
    }

    const clone = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        searchCloneById(model.departmentId)
        setTabIndex("2");
        setFlag("clone");

    }
    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            moduleCode: model.moduleCode ?? "",
            moduleName: model.moduleName ?? "",
            moduleNameSc: model.moduleNameSc ?? "",
            moduleNameTc: model.moduleNameTc ?? "",
            activeInd: model.activeInd ?? '',
            inactiveDate: (model.inactiveDate && moment(model.inactiveDate)) ?? null,
            lastUpdatedDate: model.lastUpdatedDate ?? "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = moduleModel;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("module/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "module/insert";
        } else if (flag === 'edit') {
            url = "module/update"
            values.moduleId = moduleModel.moduleId;
            values.lastUpdatedDate = moduleModel.lastUpdatedDate;
        } else if (flag === 'clone') {
            url = "module/clone"
            values.moduleId = moduleModel.moduleId;
            values.lastUpdatedDate = moduleModel.lastUpdatedDate;
        }
        if (values.activeInd === 'Y') {
            values.inactiveDate = null
        }
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("module/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let moduleModel = data.object;
                initForm(moduleModel);
                setModuleModel(moduleModel)
                setFlag("edit");
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const searchCloneById = (model) => {
        setIsLoading(true);
        Base.callBackApi("department/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let moduleModel = data.object;
                initForm(moduleModel);
                setModuleModel(moduleModel)
                setFlag("clone");
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        setGroupMemberTables([]);
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e, type) => {
        e.stopPropagation();
        setModuleModel(model)
        setIsDeleteFrame(true);
        if (type == "segment") {
            setDeleteTipText("Module Code" + ":" + model.moduleCode + "")
        }
    }


    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    /*eslint-disable*/
    const columns = [
        {
            title: 'Module Code',
            dataIndex: 'moduleCode',
            className: 'tableWidth20',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'moduleCode') },
        },
        {
            title: 'Module Name',
            dataIndex: 'moduleName',
            className: 'tableWidth30',
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            className: 'tableWidth20',
        },
        {
            title: 'Last Updated By',
            dataIndex: 'lastUpdatedBy',
            className: 'tableWidth20',
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'activeInd',
            className: 'tableWidth10',
            render: (text) => ContextHandler.getMapValueTransalation('activeTransalation', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 206,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e, "segment")} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];


    return (
        <div id="container" className="template module">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle ">{trans.departmentId[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" placeholder={trans.departmentId[Config.backLang]} value={searchModel.moduleCode || ''}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('moduleCode', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle ">{trans.departmentName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" placeholder={trans.departmentName[Config.backLang]} value={searchModel.moduleName || ''}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('moduleName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle ">Created By</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" placeholder="Created By" value={searchModel.createdBy || ''}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('createdBy', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle ">Last Updated By</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" placeholder="Last Updated By" value={searchModel.lastUpdatedBy || ''}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('lastUpdatedBy', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1000 }}
                                    rowKey="moduleId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,                        //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,                //当前页
                                        pageSize: pageSize,              //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.departmentId[Config.backLang]}</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="moduleCode"
                                                getValueFromEvent={(e) => Base.codeChange(e, 20)}
                                                rules={[
                                                    { required: true, message: trans.departmentIdNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.departmentId[Config.backLang]} maxLength={30} disabled={flag === 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {/* <div className='sysCol'>
                                        <div className="sysParam sysParamInput ">{trans.departmentDisplayCode[Config.backLang]}</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="displayCode"
                                                getValueFromEvent={(e) => Base.codeChange(e, 20)}
                                            >
                                                <Input type="text" placeholder={trans.departmentDisplayCode[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div> */}

                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.departmentName[Config.backLang]}</div>
                                        <div className="sysInputMax ">
                                            <Form.Item
                                                name="moduleName"
                                                rules={[
                                                    { required: true, message: trans.departmentNameNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.departmentName[Config.backLang]} maxLength={60} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput ">{trans.departmentNameSC[Config.backLang]}</div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="moduleNameSc"
                                            >
                                                <Input type="text" placeholder={trans.departmentNameSC[Config.backLang]} maxLength={60} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput ">{trans.departmentNameTC[Config.backLang]}</div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="moduleNameTc"

                                            >
                                                <Input type="text" placeholder={trans.departmentNameTC[Config.backLang]} maxLength={60} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.activeInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.activeIndIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select placeholder={trans.activeInd[Config.backLang]} className='sysSelect'
                                                    onChange={(e) => {
                                                        if (e === 'N') {
                                                            form.setFieldValue('inactiveDate', moment())
                                                        } else {
                                                            form.setFieldValue('inactiveDate')
                                                        }
                                                    }}
                                                >
                                                    <Option value=""></Option>
                                                    {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    {activeInd === 'N' ?
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">{trans.inactiveDate[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                    rules={[
                                                        { required: true, message: 'Inactive Date is required.' },
                                                    ]}
                                                >
                                                    <DatePicker placeholder={trans.inactiveDate[Config.backLang]}
                                                        className="parts-numberInput datePickerAllWidth"
                                                        disabledDate={disabledDate}
                                                        format={Config.dateFormat5} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        :
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">{trans.inactiveDate[Config.backLang]} </div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                >
                                                    <DatePicker placeholder={trans.inactiveDate[Config.backLang]}
                                                        className="parts-numberInput datePickerAllWidth"
                                                        disabled
                                                        format={Config.dateFormat5} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default Department;